import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ThumbsUp = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M6.75 10.75h-3a1 1 0 0 0-1 1v7.5a1 1 0 0 0 1 1h3m0 0V11l3.97-7.708c.172-.333.516-.542.891-.542a2.003 2.003 0 0 1 1.98 2.308l-.575 3.692h5.243a3 3 0 0 1 2.966 3.451l-.837 5.5a3 3 0 0 1-2.966 2.549z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.611 2c-.654 0-1.256.365-1.557.949L6.421 10H3.75A1.75 1.75 0 0 0 2 11.75v7.5c0 .966.784 1.75 1.75 1.75h13.672a3.75 3.75 0 0 0 3.707-3.186l.837-5.5A3.75 3.75 0 0 0 18.26 8h-4.367l.44-2.826A2.753 2.753 0 0 0 11.612 2M6 11.5v8H3.75a.25.25 0 0 1-.25-.25v-7.5a.25.25 0 0 1 .25-.25z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
